<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/leaves">{{$t('leave_category')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>

        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.Code.required">- សូមធ្វើការបញ្ជូលកូដ</div>
                        <div class="error" v-if="!$v.model.Description.required">- សូមធ្វើការបញ្ជូល{{$t('description')}}</div>
                    </div>
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="form-group" :class="{'form-group-error': $v.model.Code.$error}">
                                    <label class="label-control blue">{{$t('code')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" v-model="model.Code"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Description.$error }">
                                    <label class="label-control blue">{{$t('description')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" v-model="$v.model.Description.$model"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group blue">
                                    <input type="checkbox" v-model="model.UnPaid" /> {{$t('leave_un_paid')}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group blue">
                                    <input type="checkbox" v-model="model.IsBringForward" /> {{$t('leave_is_bring_forward')}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group blue">
                                    <input type="checkbox" v-model="model.IsUnlimited" /> {{$t('leave_is_unlimited')}}
                                </div> 
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <table class="table table-bordered table-sm no-bor">
                                    <thead>
                                        <tr>
                                            <th style="width: 30px;" class="text-center">
                                                <input type="checkbox" @click="allClick" />
                                            </th>
                                            <th>{{$t('code')}}</th>
                                            <th>{{$t('description')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="ret in schemes" :key="ret.Id">
                                            <td class="text-center">
                                                <input type="checkbox" v-model="ret.Checked" />
                                            </td>
                                            <td>{{ret.Code}}</td>
                                            <td>{{ret.Description}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br>
                        <template v-if="!model.IsUnlimited">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group blue">
                                        <input type="checkbox" v-model="model.IsFixed" /> {{$t('leave_is_fixed')}}
                                    </div> 
                                </div>
                                <div class="col-sm-1" v-if="model.IsFixed">
                                    <div class="form-group">
                                        <input type="number" class="form-control form-control-sm" v-model="model.Earned" />
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!model.IsFixed">
                                <div class="col-sm-4">
                                    <table class="grid">
                                        <thead>
                                            <tr>
                                                <th>{{$t('from_year')}}</th>
                                                <th>{{$t('to_year')}}</th>
                                                <th>{{$t('entitle_day')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="ret in entitles" :key="ret.Id">
                                                <td><input type="number" class="form-control form-control-sm" min="0" v-model="ret.FromYear" /></td>
                                                <td><input type="number" class="form-control form-control-sm" min="0" v-model="ret.ToYear"></td>
                                                <td><input type="number" class="form-control form-control-sm" min="0" v-model="ret.EntitleDay" /></td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="3">
                                                    <a href="javascript:void(0)" class="btn btn-danger btn-sm" @click="onAddRow"><i class="fa fa-plus-circle" aria-hidden="true"></i> {{$t('new')}}</a>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </template>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        data: function () {
            return {
                model: {
                    Code: '',
                    Description: '',
                    UnPaid: false,
                    IsBringForward: false,
                    IsUnlimited: false,
                    IsFixed: false,
                    Earned: 0
                },
                schemes: [],
                entitles: [
                    {
                        FromYear: 0,
                        ToYear: 0,
                        EntitleDay: 0
                    }
                ],
                actionLink: 'leave/save',
                title: this.$t('leave_type_create')
            }
        },
        validations: {
            model: {
                Code: {required},
                Description: {required}
            }
        },
        async created() {
            const id = this.$route.params.id;
            await this.schemeList();
            if(id !== undefined && id != null && id !== ''){
                this.title = this.$t('leave_type_update');
                this.findById(id);
            }
        },
        methods:{
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('leave/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                        let links = res.data.Json.Links;
                        this.schemes.forEach(el => {
                            if(links.includes(el.Id)) el.Checked = true;
                        });
                        this.entitles = res.data.Json.Entitles;
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler(){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    var loading = this.$loading.show();
                    this.model.Date = this.date;
                    var req = {
                        LeaveType: this.model,
                        Links: [],
                        Entitles: this.entitles
                    };
                    this.schemes.forEach(ele => {
                        if(ele.Checked) req.Links.push({ LeaveSchemeId: ele.Id });
                    });
                    this.$api().post(this.actionLink, req).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/leaves');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            async schemeList() {
                var res = await this.$api().post('schemes', { Limit: 0 });
                if (this.$isValid(res)) {
                    this.schemes = res.data.Json.Schemes;
                }
            },
            allClick(e){
                this.schemes.forEach(element => {
                    element.Checked = e.target.checked;
                });
            },
            onAddRow(){
                this.entitles.push({
                    FromYear: 0,
                    ToYear: 0,
                    EntitleDay: 0
                });
            }
        }
    }
</script>